import React, { Component } from 'react'
import { getUser } from '../../actions/session'
import Axios from 'axios'
import { Notifications } from '../common/notification';
import { CARRIER_UPDATE } from '../../config/rest_endpoints';
import Switch from "react-switch";


class CarrierEdit extends Component {
    constructor(props) {
        super(props)
        this.state = {
            User: getUser(),
            U_carrierId: '',
            U_session: '',
            U_cps: '',
            U_prefix: '',
            U_status: '',
            msg: '',
            prefix: '',
            holdTime:'',
            name:'',
            switched: true,
            isLoad: false
        }
        this.handleChange = this.handleChange.bind(this)
        this.handleSubmit = this.handleSubmit.bind(this)
        this.toggleSwitch = this.toggleSwitch.bind(this)
    }

    componentWillReceiveProps(newProps) {
        const {previousData} = newProps
        this.setState({
            U_session: previousData.sessions === undefined ? "" : previousData.sessions,
            U_cps:previousData['cps'] === undefined ? "" : previousData['cps'] ,
            prefix: previousData.prefix === undefined ? "" : previousData.prefix,
            switched:previousData.status ,
            holdTime:previousData.holdTime  === undefined ? "" : previousData.holdTime  ,
            name:previousData.name
            // U_carrierId:newProps.previousData.carrierID,
            // U_prefix:newProps.previousData.prefix,
            // U_status:newProps.previousData.status
        })
    }

    toggleSwitch() {
        this.setState({ switched: !this.state.switched })
    }

    handleChange(e) {
        this.setState({
            [e.target.name]: e.target.value
        })
    }

    handleSubmit() {
        const { previousData } = this.props
        const { U_cps, U_session, carrierId, switched, prefix, holdTime, name } = this.state
        var id = previousData.id
        var spID = '5e53b3847d43000085004d04'
        console.log('name :>> ', name);
        var payload = {
            "name":name,
            "carrierID": parseInt(previousData.carrierID),
            "sessions": parseInt(U_session),
            "cps": parseInt(U_cps),
            "holdTime": parseInt(holdTime) ,
            "prefix": prefix === '' ? null : prefix,
            "status": switched
        }
        this.setState({ isLoad: true })
        var headers = { 'Authorization': "Bearer " + this.state.User.token }
        Axios.put(`${CARRIER_UPDATE}/${id}/update`, payload, { headers }).then(res => {
            if (res) {
                this.props.close()
                this.props.carrierListing()
                this.setState({ isLoad: false })
                Notifications.notify("Carriers updated successfully", "Created", "success")
            }
            else {
                Notifications.notify("failed carrier update", "Failed", "error")
            }
        }).catch(err => {
            var msessage = err.response.data.message
            console.log(`msessage`, msessage)
            this.setState({ isLoad: false })
            Notifications.notify(msessage, "Failed", "error")
            this.props.close()
        })
    }

    render() {
        const { U_cps, U_session, prefix, holdTime,name } = this.state
        return (
            <div>
                <div className='row'>
                    <div className='col-md-6'>
                        <div className="form-group">
                        <label style={{fontWeight:'400',fontSize:'16px'}} >Name</label>
                        <input type="text" className="form-control" name="name" value={name} onChange={this.handleChange} placeholder="Enter name" />
                        </div>
                    </div>
                    <div className='col-md-6'>
                        <div className="form-group">
                        <label style={{fontWeight:'400',fontSize:'16px'}} >Session</label>
                        <input type="number" className="form-control" name="U_session" value={U_session} onChange={this.handleChange} placeholder="Enter concurrent calls" />
                        </div>
                    </div>
                    <div className='col-md-6'>
                        <div className="form-group">
                        <label style={{fontWeight:'400',fontSize:'16px'}}>CPS</label>
                        <input type="number" className="form-control" name="U_cps" value={U_cps} onChange={this.handleChange} placeholder="Enter CPS" />
                        </div>
                    </div>
                    <div className='col-md-6'>
                        <div className="form-group">
                        <label style={{fontWeight:'400',fontSize:'16px'}}>Prefix</label>
                        <input type="text" className="form-control" name="prefix" value={prefix} onChange={this.handleChange} placeholder="e.g. 3353#" />
                        </div>
                    </div>
                    <div className='col-md-6'>
                        <div className="form-group">
                        <label style={{fontWeight:'400',fontSize:'16px'}}>Hold Time</label>
                        <input type="text" className="form-control" name="holdTime" value={holdTime} onChange={this.handleChange} placeholder="Enter hold time" />
                        </div>
                    </div>
                    <div className='col-md-6'>
                        <div className="form-group mt-1">
                            <div className="row">
                                <div className="col-md-3 mt-1">
                                    <label style={{fontWeight:'400',fontSize:'16px'}} className="fs-14" >Carrier Status</label>
                                </div>
                                <div className="col-md-1 mr-3">
                                    <Switch onChange={this.toggleSwitch} checked={this.state.switched} onColor="#00C292" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                 
                
             
               
                
                
                <div className="row" style={{borderTop:'1px solid #e9ecef'}}>
                    <div className="col-md-6 ml-auto">
                        <button type="submit " className="main-button btn btn-sm btn-success mt-2 float-right" onClick={this.handleSubmit} >Update Carrier  <i class={this.state.isLoad ? "icon-spinner4 spinner ml-1 " :"icon-pencil5 ml-1 icon-1x"}></i></button>
                    </div>
                </div>
            </div>
        )
    }
}
export default CarrierEdit